import { render, staticRenderFns } from "./SmartApproachApp.vue?vue&type=template&id=529c6645&scoped=true&"
import script from "./SmartApproachApp.vue?vue&type=script&lang=ts&"
export * from "./SmartApproachApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c6645",
  null
  
)

export default component.exports